import { Spin } from 'antd';

interface LoadingOverlayProps {
  visible: boolean;
  tip?: string;
}

export function LoadingOverlay({ visible, tip = 'Processando...' }: LoadingOverlayProps) {
  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Spin size="large" tip={tip} />
    </div>
  );
}
